import React, { useState, useMemo, useEffect, useRef } from 'react';
import { Popover, Tooltip } from 'antd';
import { apiHolder, apis } from 'api';
import classnames from 'classnames';
import styles from './mailDiscuss.module.scss';
import IconCard from '@web-common/components/UI/IconCard';
import MailDiscussPopover from '../MailDiscussPopover/mailDiscussPopover';
import useDebounceForEvent from '@web-mail/hooks/useDebounceForEvent';
import { getIn18Text } from 'api';
const discussApi = apiHolder.api.requireLogicalApi(apis.imDiscussApiImpl);
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const sysApi = apiHolder.api.getSystemApi();
const nimApi = apiHolder.api.requireLogicalApi('NIM');
const MailDiscuss = props => {
    const { id, style, keyIds } = props;
    const popoverRef = useRef(null);
    const [teamMsgs, setTeamMsgs] = useState({
        ownTeams: [],
        joinTeams: [],
    });
    const midRef = useRef('');
    const isMounted = useRef(false);
    const teamCount = useMemo(() => {
        const { ownTeams, joinTeams } = teamMsgs;
        return ownTeams.length + joinTeams.length;
    }, [teamMsgs]);
    const resetTeamMsgs = () => {
        setTeamMsgs({
            ownTeams: [],
            joinTeams: [],
        });
    };
    const getMailDiscuss = async () => {
        var _a;
        midRef.current = keyIds.mid;
        const currentUser = sysApi.getCurrentUser();
        const contactInfo = (_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.contact) === null || _a === void 0 ? void 0 : _a.contactInfo;
        if (!contactInfo) {
            return;
        }
        const yunxinInfo = contactInfo.find(item => item.contactItemType === 'yunxin');
        if (!yunxinInfo) {
            return;
        }
        try {
            const { contactItemVal: yxAccId } = yunxinInfo;
            const res = await discussApi.getMailDiscuss({
                yxAccId,
                emailTid: keyIds.tid || '',
                emailMid: keyIds.mid || '',
            });
            if (!isMounted.current) {
                console.warn('mailDiscuss done component unmounted');
                return;
            }
            if (res.code === 0) {
                if (midRef.current === keyIds.mid) {
                    const { ownTeams, joinTeams } = res === null || res === void 0 ? void 0 : res.data;
                    setTeamMsgs({ ownTeams: ownTeams || [], joinTeams: joinTeams || [] });
                }
                else {
                    console.warn('mailDiscuss id 不一致');
                }
            }
            else {
                console.warn(getIn18Text('JIEKOUHUOQUYOU'), res.message);
            }
        }
        catch (error) {
            console.error(getIn18Text('HUOQUYOUJIANTAO'), error);
        }
    };
    const debounceGetMailDiscuss = useDebounceForEvent(() => {
        getMailDiscuss();
    }, 600, { leading: false });
    const onVisibleChange = (vis) => {
        if (vis) {
            trackApi.track('pcmail_hover_mailDetail_mailChatButton', {});
            debounceGetMailDiscuss();
        }
    };
    useEffect(() => {
        isMounted.current = true;
        if (keyIds === null || keyIds === void 0 ? void 0 : keyIds.mid) {
            debounceGetMailDiscuss();
        }
        else {
            resetTeamMsgs();
        }
        return () => {
            isMounted.current = false;
        };
    }, [keyIds.mid]);
    if (teamCount === 0 && !nimApi.getIMAuthConfig()) {
        return null;
    }
    const popOverCont = () => React.createElement(MailDiscussPopover, { mailMid: keyIds === null || keyIds === void 0 ? void 0 : keyIds.mid, teamMsgs: teamMsgs, teamCount: teamCount, closePopover: () => { var _a; return (_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.close(); } });
    return (React.createElement(Popover, { placement: "bottomRight", trigger: "click", title: "", content: popOverCont, onVisibleChange: onVisibleChange, ref: popoverRef },
        React.createElement(Tooltip, { title: getIn18Text('YOUJIANTAOLUN'), trigger: "hover", placement: "bottom", mouseEnterDelay: 0.3, mouseLeaveDelay: 0.15, destroyTooltipOnHide: true },
            React.createElement("div", { id: id || 'mailDiscuss', className: classnames(styles.mailDiscussArea), style: style || {}, onClick: e => e.stopPropagation() },
                React.createElement("span", { className: styles.discussIcon },
                    React.createElement(IconCard, { type: teamCount > 0 ? 'greenDiscuss' : 'discuss' }))))));
};
export default MailDiscuss;
